import { createFileRoute } from "@tanstack/react-router"

import { PassesIndexRouteComponent } from "@/routes/_authenticated/account/passes/index"

export const Route = createFileRoute(
  "/qr/$qrLookupID/_authenticated/account/passes/"
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <PassesIndexRouteComponent />
}
